const prefix = 'str-';

export const getLocalStorage = (key) => {
    if (typeof window !== 'undefined') {
        return window.localStorage.getItem(`${prefix}${key}`);
    }
    return null;
};

export const setLocalStorage = (key, value) => {
    if (typeof window !== 'undefined') {
        window.localStorage.setItem(`${prefix}${key}`, value);
    }
};
